import React, { useEffect, useState } from "react";
import { Form, Col, Row, message, Upload, Button, Card } from "antd";
import { API_METHODS } from "../../constants";
import useApi from "../../hooks/useApi";
import { InboxOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function UploadDailyContent() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [disableForm, setDisableForm] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [uploadDailyContentResponse, uploadDailyContentRequest] = useApi(
    `/admin/daily-content/upload`,
    null,
    API_METHODS.POST,
    true // for multipart data
  );

  useEffect(() => {
    if (uploadDailyContentResponse.data) {
      setDisableForm(false);
      messageApi.open({
        type: "success",
        content: "Daily Content added successfully",
      });

      navigate("/portal/daily-content");
    } else if (uploadDailyContentResponse.error) {
      setDisableForm(false);
      messageApi.open({
        type: "error",
        content: uploadDailyContentResponse.error,
      });
      navigate("/portal/daily-content");
    }
  }, [uploadDailyContentResponse]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type === "image/png" || file.type === "image/jpeg";
      if (!isImage) {
        messageApi.open({
          type: "error",
          content: `${file.name} error. Only PNG and JPEG files supported`,
        });
        return Upload.LIST_IGNORE;
      }
      return isImage;

      //    return new Promise((resolve, reject) => {
      //      const reader = new FileReader();
      //      reader.onload = (e) => {
      //        const img = new Image();
      //        img.onload = () => {
      //          const aspectRatio = img.width / img.height;
      //          if (aspectRatio !== 0.8) {
      //            // 4:5 aspect ratio
      //            message.error("Image aspect ratio must be 4:5!");
      //            reject();
      //          } else {
      //            resolve();
      //          }
      //        };
      //        img.src = e.target.result;
      //      };
      //      reader.readAsDataURL(file);
      //    });
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const onFinish = (values) => {
    setDisableForm(true);
    const formData = new FormData();
    for (const name in values) {
      if (name === "image") {
        if (values["image"] !== undefined) {
          formData.append(
            "image",
            values["image"].file.originFileObj,
            values["image"].file.name
          );
        }
      }
    }
    uploadDailyContentRequest(formData);
  };

  return (
    <Card title="Upload Daily Content">
      {contextHolder}
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        disabled={disableForm}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="image"
              rules={[
                { required: true, message: "Daily Content is required." },
              ]}
            >
              <Upload.Dragger
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={1}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ float: "right" }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default UploadDailyContent;
